import { axiosInstance } from "@/apis/core";

// ============================================
// 장소 관리 API
// ============================================

export const createBuilding = async (data: {
  cpsCd: string;
  bldNm: string;
}) => {
  const res = await axiosInstance.post(
    "/portal-service/api/v1/building/create",
    data,
  );
  return res.data;
};

export const updateBuilding = async (data: {
  bldCd: string;
  bldNm: string;
}) => {
  const res = await axiosInstance.put(
    "/portal-service/api/v1/building/update",
    data,
  );
  return res.data;
};

export const deleteBuilding = async (bldCd: string) => {
  const res = await axiosInstance.put(
    "/portal-service/api/v1/building/delete",
    { bldCd },
  );
  return res.data;
};

export const createPlace = async (data: {
  cpsCd: string;
  bldCd: string;
  plcNm: string;
  plcF: number;
}) => {
  const res = await axiosInstance.post(
    "/portal-service/api/v1/place/create",
    data,
  );
  return res.data;
};

export const updatePlace = async (data: {
  plcCd: string;
  plcNm: string;
  plcF: number;
}) => {
  const res = await axiosInstance.put(
    "/portal-service/api/v1/place/update",
    data,
  );
  return res.data;
};

export const deletePlace = async (plcCd: string) => {
  const res = await axiosInstance.put("/portal-service/api/v1/place/delete", {
    plcCd,
  });
  return res.data;
};

// 장소 상세 조회 (이미지 포함)
export const fetchPlaceDetail = async (plcCd: string) => {
  const res = await axiosInstance.get(
    `/portal-service/api/v1/place/detail?plcCd=${plcCd}`,
  );
  return res.data;
};

// 장소 상세 수정 (이름, 층, 설명)
export const updatePlaceDetail = async (data: {
  plcCd: string;
  plcNm: string;
  plcF: number;
  description?: string;
}) => {
  const res = await axiosInstance.put(
    "/portal-service/api/v1/place/detail/update",
    data,
  );
  return res.data;
};

// 장소 이미지 업로드 (JPG, PNG, WebP / 최대 5MB)
export const uploadPlaceImage = async (plcCd: string, file: File) => {
  const formData = new FormData();
  formData.append("plcCd", plcCd);
  formData.append("image", file);
  const res = await axiosInstance.post(
    "/portal-service/api/v1/place/image/upload",
    formData,
    { headers: { "Content-Type": undefined as unknown as string } },
  );
  return res.data;
};

// 장소 이미지 삭제
export const deletePlaceImage = async (imgId: number) => {
  const res = await axiosInstance.put(
    "/portal-service/api/v1/place/image/delete",
    { imgId },
  );
  return res.data;
};

// ============================================
// 조직 관리 API
// ============================================

export const createCommunity = async (data: {
  cpsCd: string;
  cmtNm: string;
}) => {
  const res = await axiosInstance.post(
    "/user-service/api/v1/community/create",
    data,
  );
  return res.data;
};

export const updateCommunity = async (data: {
  cmtCd: string;
  cmtNm: string;
}) => {
  const res = await axiosInstance.put(
    "/user-service/api/v1/community/update",
    data,
  );
  return res.data;
};

export const deleteCommunity = async (cmtCd: string) => {
  const res = await axiosInstance.put(
    "/user-service/api/v1/community/delete",
    { cmtCd },
  );
  return res.data;
};

export const createGarret = async (data: {
  cpsCd: string;
  cmtCd: string;
  garNm: string;
}) => {
  const res = await axiosInstance.post(
    "/user-service/api/v1/garret/create",
    data,
  );
  return res.data;
};

export const updateGarret = async (data: { garCd: string; garNm: string }) => {
  const res = await axiosInstance.put(
    "/user-service/api/v1/garret/update",
    data,
  );
  return res.data;
};

export const deleteGarret = async (garCd: string) => {
  const res = await axiosInstance.put("/user-service/api/v1/garret/delete", {
    garCd,
  });
  return res.data;
};

export const createLeaf = async (data: {
  cpsCd: string;
  cmtCd: string;
  garCd: string;
  leafNm: string;
}) => {
  const res = await axiosInstance.post(
    "/user-service/api/v1/leaf/create",
    data,
  );
  return res.data;
};

export const updateLeaf = async (data: { leafCd: string; leafNm: string }) => {
  const res = await axiosInstance.put(
    "/user-service/api/v1/leaf/update",
    data,
  );
  return res.data;
};

export const deleteLeaf = async (leafCd: string) => {
  const res = await axiosInstance.put("/user-service/api/v1/leaf/delete", {
    leafCd,
  });
  return res.data;
};

export const fetchUsersByOrg = async (params: {
  cpsCd: string;
  cmtCd?: string;
  garCd?: string;
  leafCd?: string;
}) => {
  const res = await axiosInstance.get("/user-service/api/v1/users/by-org", {
    params,
  });
  return res.data;
};

export const moveUsersOrg = async (data: {
  userIds: string[];
  cmtCd: string;
  garCd: string;
  leafCd: string;
}) => {
  const res = await axiosInstance.put(
    "/user-service/api/v1/users/move-org",
    data,
  );
  return res.data;
};
